export const iconFontAwesomeArrowsRetweet = (
	<i className="fa-solid fa-retweet"></i>
);
